/* eslint-disable prefer-destructuring */
import { useDisclosure } from '@chakra-ui/react';
import { IQuoteRespSchema, QuoteStatusEnum } from '@monetize/types/app';
import React from 'react';
import { QuoteProgressStep } from './QuoteProgressStep';

interface QuoteStepProcessProps {
  quote: IQuoteRespSchema;
  stepMessage: {
    stepDate: string | null;
    stepTitle: string;
    isError: boolean;
    showLightBackground: boolean;
  } | null;
}

export const QuoteStepProcess = React.forwardRef<any, QuoteStepProcessProps>(
  ({ quote, stepMessage }: QuoteStepProcessProps, ref) => {
    let stepTitle = 'Process Quote';
    let stepDate: string | null = quote.processedAt ?? null;
    const isCompleted = quote.status === QuoteStatusEnum.PROCESSED;

    const showInprogressStepNumber = false;
    const isCurrent =
      quote.status === QuoteStatusEnum.ACCEPTED && !!quote.acceptedAt;
    const isDisabled = false;

    if (isCompleted) {
      stepTitle = 'Processed Quote';
    }
    const popoverState = useDisclosure();

    if (stepMessage) {
      stepTitle = stepMessage.stepTitle;
      stepDate = stepMessage.stepDate;
    }

    return (
      <QuoteProgressStep
        key="quote-progress-process"
        stepTitle={stepTitle}
        stepDate={stepDate}
        stepNumber={5}
        isCompleted={isCompleted}
        showInprogressStepNumber={showInprogressStepNumber}
        isDisabled={isDisabled}
        isCurrent={isCurrent}
        containerProps={{ ml: -8 }}
        isError={stepMessage?.isError}
        showLightBackground={stepMessage?.showLightBackground}
        popoverState={popoverState}
      />
    );
  },
);
